import { queryOptions } from "@tanstack/react-query";
import { useApiClient } from "bff/ApiClientProvider";
import { minutesToMilliseconds } from "date-fns";

const reportingPrefix = 'reportingPrefix';

export const getClientPlans = () => {
  const { reportingApi } = useApiClient();
  return queryOptions({
    queryKey: [reportingPrefix, 'useGetClientPlans'],
    queryFn: () => reportingApi.reportingGetClientPlans(),
    select: (response) => response.data!,
    staleTime: minutesToMilliseconds(5)
  });
};